import React from 'react'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';


const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: "#005095",
        color: 'white',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(16),
        border: '1px solid #dadde9',
    },
    arrow: {
        "&:before": {
            border: "1px solid #E6E8ED"
        },
        color: theme.palette.common.white
    }
}));

export function TooltipButton({ children, titulo, body }) {
    return (
        <HtmlTooltip
            title={
                <React.Fragment>
                    <h4>{titulo}</h4>
                    <p>{body}</p>
                </React.Fragment>
            }
        >
            {children}
        </HtmlTooltip>
    )
}
